class UserProfile {
    constructor() {
        this.baan1 = null;
        this.baan2 = null;
        this.uren1 = null;
        this.uren2 = null;
        this.vak2 = null;
        this.onderwijsniveau = null;
        this.bevoegdheid = null;
        this.bevoegdheidIn = null;

        this.opMaat = true;
        this.opDeHoogteBrengenProjecten = true;
        this.nieuwsbrief = true;

        this.naam = null;
        this.email = null;
        this.woonplaats = null;
        this.opleiding = null;
        this.huidigeFunctie = null;
        this.hasSubmitted = false;

        this.textProfile = "";
    }

    isATeacher() {
        return this.baan1 && this.baan1.isTeacher;
    }

    isNotATeacher() {
        return this.baan1 && !this.baan1.isTeacher;
    }
}

export {
    UserProfile
};


// WEBPACK FOOTER //
// ./src/components/application/classes.js